import { useState, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { GameSection } from '../CollectionsStyles';
import AddCopyDialog from './AddCopyDialog';
import { Intent, Alert } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { toggleAddCopyDialog, toggleUploadCopiesDialog, toggleDeleteGameDialog, createDeleteGameAction } from '../collectionsActions';
import GamesList from './GamesList';
import GamesNonIdeal from './GamesNonIdeal';
import {
  PageHeader,
  PageHeaderText,
  PageHeaderTitle,
  PageHeaderSearch,
  PageHeaderSection,
  PageHeaderButtonSection,
  PageHeaderButton
} from '../../layoutComponents';
import CopiesUploadDialog from './CopiesUploadDialog';

const Games = ({ games, collectionsLoading, toggleAddCopyDialog, toggleDeleteGameDialog, toggleUploadCopiesDialog, selectedCollection, deleteGameDialogOpen, deleteGame }) => {
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogCopyId, setDialogCopyId] = useState('');
  const [filterText, setFilterText] = useState('');
  useLayoutEffect(() => {
    const gameSearch = document.getElementById('game-search');
    if (gameSearch) gameSearch.focus();
  }, [selectedCollection]);

  const onFilterTextChange = event => {
    if (event.target.value !== filterText) {
      setFilterText(event.target.value);
    }
  };

  const gameListOpenCopyDialog = (title, copyId) => {
    setDialogTitle(title);
    setDialogCopyId(copyId);
    toggleAddCopyDialog();
  };

  const gameListOpenDeleteDialog = (title) => {
    setDialogTitle(title);
    toggleDeleteGameDialog();
  };

  const copyDialogClosing = () => {
    setDialogTitle('');
    setDialogCopyId('');
  };

  const deleteDialogClosing = () => {
    setDialogTitle('');
    toggleDeleteGameDialog();
  };

  let pageBody;

  if (!selectedCollection || !games || !Object.keys(games).length) {
    pageBody = <GamesNonIdeal selectedCollection={selectedCollection} />;
  } else {
    pageBody = (
      <GamesList
        collectionsLoading={collectionsLoading}
        games={games}
        openCopyDialog={gameListOpenCopyDialog}
        openDeleteDialog={gameListOpenDeleteDialog}
        filterText={filterText}
      />
    );
  }

  return (
    <GameSection>
      <AddCopyDialog
        close={toggleAddCopyDialog}
        onClosed={copyDialogClosing}
        title={dialogTitle}
        copyId={dialogCopyId}
      />
      <Alert
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
        icon="info-sign"
        intent={Intent.DANGER}
        isOpen={deleteGameDialogOpen}
        onCancel={deleteDialogClosing}
        onConfirm={() => deleteGame(dialogTitle)}
      >
        <p>Are you sure you want to delete {dialogTitle}?</p>
      </Alert>
      <CopiesUploadDialog />
      {selectedCollection && (
        <PageHeader>
          <PageHeaderSection>
            <PageHeaderText>Search:</PageHeaderText>
            <PageHeaderSearch
              id='game-search'
              className='bp5-dark'
              placeholder='Game Title'
              autoFocus={true}
              onChange={event => onFilterTextChange(event)}
              type='search'
            />
          </PageHeaderSection>
          <PageHeaderTitle>Games</PageHeaderTitle>
          <PageHeaderButtonSection>
            <PageHeaderButton
              text='Add Game'
              rightIcon={IconNames.ADD}
              intent={Intent.PRIMARY}
              onClick={toggleAddCopyDialog}
            />
            <PageHeaderButton text='Upload' intent={Intent.PRIMARY} onClick={toggleUploadCopiesDialog} />
          </PageHeaderButtonSection>
        </PageHeader>
      )}
      {pageBody}
    </GameSection>
  );
};
const mapState = state => ({
  collectionsLoading: state.collections.loading,
  selectedCollection: state.collections.selectedCollection,
  deleteGameDialogOpen: state.collections.deleteGameDialogOpen
});
const mapDispatch = dispatch => ({
  toggleAddCopyDialog: () => dispatch(toggleAddCopyDialog()),
  toggleDeleteGameDialog: () => dispatch(toggleDeleteGameDialog()),
  toggleUploadCopiesDialog: () => dispatch(toggleUploadCopiesDialog()),
  deleteGame: title => dispatch(createDeleteGameAction(title))
});

export default connect(
  mapState,
  mapDispatch
)(Games);
